import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "w-100 h-100",
  src: "https://admin.logicworld.net"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("iframe", _hoisted_1))
}